import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const VideoIcon = ({ label = 'Video', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M229.3 54.7H70.8a17.2 17.2 0 0 0-17.1 17.1v158.5a17.2 17.2 0 0 0 17.1 17.1h158.5a17.2 17.2 0 0 0 17.1-17.1V71.8a17.2 17.2 0 0 0-17.1-17.1zM103.8 208.1V94a2.9 2.9 0 0 1 4.3-2.5l98.8 57.1a2.8 2.8 0 0 1 0 4.9l-98.8 57.1a2.9 2.9 0 0 1-4.3-2.5z" style="fill:#ee8875"/><path d="M229.3 54.7a17.2 17.2 0 0 1 17.1 17.1v158.5a17.2 17.2 0 0 1-17.1 17.1H70.8a17.2 17.2 0 0 1-17.1-17.1V71.8a17.2 17.2 0 0 1 17.1-17.1h158.5M106.7 210.9l1.4-.3 98.8-57.1a2.8 2.8 0 0 0 0-4.9l-98.8-57.1-1.4-.3a2.8 2.8 0 0 0-2.9 2.8v114.1a2.8 2.8 0 0 0 2.9 2.8M229.3 44.7H70.8a27.1 27.1 0 0 0-27.1 27.1v158.5a27.1 27.1 0 0 0 27.1 27.1h158.5a27.2 27.2 0 0 0 27.1-27.1V71.8a27.2 27.2 0 0 0-27.1-27.1zm-115.5 151v-89.3l77.3 44.7-77.3 44.6z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

VideoIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { VideoIcon }
